import React from 'react'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { withTranslation } from 'react-i18next'
import { isClient } from '../../../helpers/isClient'

interface Props {
  fields: {
    IsMobileView: boolean
    ScriptUrl: string
    JqueryUrl: string
  }
  sitecoreContext: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    route: any
    pageEditing: boolean
  }
}

const BodyTopAnalytics: React.FC<Props> = (props) => {
  const {
    fields,
    sitecoreContext,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sitecoreContext: { route },
  } = props

  const isEditing = sitecoreContext && sitecoreContext.pageEditing

  const scriptUrl = fields.ScriptUrl
  const jqueryUrl = fields.JqueryUrl

  if (isClient) {
    window.EnableCookieBanner = true
    window.IsMobileApp = fields.IsMobileView
  }

  React.useEffect(() => {
    if (isClient && scriptUrl) {
      const script = document.createElement('script')
      script.src = scriptUrl
      script.async = true

      document.body.appendChild(script)

      return (): void => {
        if (document.body?.replaceChildren) {
          document.body?.replaceChildren(script)
        }
      }
    }
  }, [])

  return !isEditing ? (
    <>
      <script src={jqueryUrl}></script>
    </>
  ) : null
}

export default withSitecoreContext()(withTranslation()(BodyTopAnalytics as React.FC) as React.FC)
